import data from './portStatus.json';

/**
 * How far each admin portal feature has moved to CPX (Azure exit WS8).
 *
 * THE LIST IS portStatus.json, keyed by feature, and it is the only place a status
 * lives: no page or menu item carries its own label. README rule 8b: whoever moves
 * something staff do in the admin portal changes its status in the same commit as
 * the change. Run `npm run test:port-status` before committing.
 *
 * A feature belongs to an admin portal screen, so a page that only exists in CPX has
 * no entry and shows no badge. A "Not ported" feature can still list a CPX page: the
 * page shares the name or sits where the job belongs, and does not do this job yet.
 * "Fully ported" needs a `parity` entry saying when the
 * WS8 parity test passed and where the evidence is; the test script refuses it
 * without one.
 */
export const PORT_STATUS = {
  not: { label: 'Not ported', short: 'Not' },
  partial: { label: 'Partially ported', short: 'Partial' },
  full: { label: 'Fully ported', short: 'Full' },
};

export const PORT_FEATURES = data.features;

const byPage = {};
PORT_FEATURES.forEach((f) => {
  (f.cpxPages || []).forEach((page) => {
    if (!byPage[page]) byPage[page] = [];
    byPage[page].push(f);
  });
});

export function featuresForPage(page) {
  return byPage[page] || [];
}

// The one status a page shows: Not or Full only when all its features are, otherwise
// Partial, because Order Details with one missing button is not "Not ported". Null for a
// CPX-only page.
export function statusForPage(page) {
  const features = featuresForPage(page);
  if (features.length === 0) return null;
  if (features.every((f) => f.status === 'not')) return 'not';
  if (features.every((f) => f.status === 'full')) return 'full';
  return 'partial';
}

export function portCounts(features = PORT_FEATURES) {
  const counts = { not: 0, partial: 0, full: 0 };
  features.forEach((f) => { counts[f.status] += 1; });
  return counts;
}
